<div class="modal fade" id="createLobbyModal" tabindex="-1" aria-labelledby="createLobbyModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5 text-white" id="createLobbyModalLabel">Create Lobby</h1>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"
                    aria-label="Close"></button>
            </div>
            <div class="modal-body text-white">
                <form [formGroup]="lobbyForm">
                    <div class="form-floating mb-3">
                        <input formControlName="title" class="form-control text-white bg-dark border-secondary" placeholder="Lobby Title" />
                        <label class="text-white-50">Title</label>
                        @if (lobbyForm.controls.title.invalid && lobbyForm.controls.title.touched) {
                            <div class="text-danger small mt-1">Title is required and must be between 3 and 50 characters.</div>
                        }
                    </div>

                    <div class="form-floating mb-3">
                        <textarea formControlName="description" style="height: 100px;" class="form-control text-white bg-dark border-secondary"
                            placeholder="Lobby Description"></textarea>
                        <label class="text-white-50">Description</label>
                        @if (lobbyForm.controls.description.invalid && lobbyForm.controls.description.touched) {
                            <div class="text-danger small mt-1">Description must be under 200 characters.</div>
                        }
                    </div>

                    <div class="form-floating mb-3">
                        <input type="password" formControlName="password" class="form-control text-white bg-dark border-secondary" placeholder="Password" />
                        <label class="text-white-50">Password (Optional)</label>
                    </div>

                    <div class="form-check form-check-inline mb-3">
                        <input type="checkbox" class="form-check-input" formControlName="isPublic" id="isPublicLobby" />
                        <label class="form-check-label" for="isPublicLobby">Public</label>
                    </div>

                    <div class="form-check form-check-inline mb-3">
                        <input type="checkbox" class="form-check-input" formControlName="isStatic" id="isStaticLobby" />
                        <label class="form-check-label" for="isStaticLobby">Static</label>
                    </div>

                    <div class="form-check form-check-inline mb-3">
                        <input type="checkbox" class="form-check-input" formControlName="hasVoice" id="hasVoiceLobby" />
                        <label class="form-check-label" for="hasVoiceLobby">Voice</label>
                    </div>

                    <div class="form-check form-check-inline mb-3">
                        <input type="checkbox" class="form-check-input" formControlName="hasVideo" id="hasVideoLobby" />
                        <label class="form-check-label" for="hasVideoLobby">Video</label>
                    </div>

                    <div class="form-check form-check-inline mb-3">
                        <input type="checkbox" class="form-check-input" formControlName="hasImages" id="hasImagesLobby" />
                        <label class="form-check-label" for="hasImagesLobby">Images</label>
                    </div>

                    <div class="form-floating mb-3">
                        <input formControlName="motd" class="form-control text-white bg-dark border-secondary" placeholder="Message of the Day" />
                        <label class="text-white-50">Message of the Day</label>
                        @if (lobbyForm.controls.motd.invalid && lobbyForm.controls.motd.touched) {
                            <div class="text-danger small mt-1">MOTD must be under 100 characters.</div>
                        }
                    </div>

                    <div class="form-floating mb-3">
                        <input formControlName="url" class="form-control text-white bg-dark border-secondary" placeholder="Optional URL" />
                        <label class="text-white-50">Optional URL</label>
                    </div>

                    <div class="dropdown">
                        <button class="btn btn-xl btn-outline-primary dropdown-toggle d-flex align-items-center" type="button" id="lobbyIconDropdownButton"
                            [class.is-invalid-icon]="lobbyForm.controls.avatarURL.invalid && lobbyForm.controls.avatarURL.touched"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            @if(selectedIcon()) {
                            <img src="{{lobbyForm.controls.avatarURL.value}}" class="me-2" width="64" height="64"
                                alt="Selected Icon" style="object-fit: cover; border-radius: 4px;" />
                            }@else{
                                <img src="/images/logo_1_2.png" class="me-2" width="64" height="64"
                                alt="Default Icon" style="object-fit: cover; border-radius: 4px;" />
                            }
                            {{ selectedIcon() ? 'Change Icon' : 'Select Icon' }}
                        </button>

                        @if(lobbyForm.controls.avatarURL.invalid && lobbyForm.controls.avatarURL.touched) {
                        <div class="small text-danger mt-2">
                            Please select a lobby icon.
                        </div>
                        }

                        <ul class="dropdown-menu bg-dark text-white p-2 border-secondary" aria-labelledby="lobbyIconDropdownButton"
                            style="max-height: 300px; overflow-y: auto;">
                            @if(arenaIcons().length > 0) {
                            <li class="text-white-50 px-3 py-1 small text-uppercase">Uploaded Icons</li>
                            @for(icon of arenaIcons(); track $index) {
                            <li class="text-white">
                                <a class="dropdown-item d-flex align-items-center py-2" (click)="selectIcon(icon)"
                                    style="cursor: pointer;">
                                    <img src="https://usercontent.h5arena.com/arenas/{{icon.guid}}{{icon.fileExtension}}" width="64" height="64" class="me-2" style="object-fit: cover; border-radius: 4px;" />
                                    {{icon.title ? icon.title: "No Title"}}
                                </a>
                            </li>
                            }
                            } @else {
                            <li class="text-white-50 px-3 py-2 small text-center">No uploaded icons available</li>
                            }
                        </ul>
                    </div>
                </form>
            </div>
            <div class="modal-footer p-0 border-0 gap-0">
                <button type="button" class="btn btn-dark w-50 m-0 rounded-0 rounded-bottom-start fw-bold"
                    style="height: 4rem;" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-danger w-50 m-0 rounded-0 rounded-bottom-end fw-bold"
                    style="height: 4rem;" (click)="create()">Create Lobby</button>
            </div>
        </div>
    </div>
</div>
